export default __webpack_public_path__ + "static/pieshow-362d6060b2c66e31012696e1f40be2a8.jpg";